export const scheduleStyles = `
    .schedule-container {
        font-family: Arial, sans-serif;
        max-width: 100vw;
        margin: 0 auto;
        padding: 20px;
    }

    .controls {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding: 10px 15px;
        background-color: #f5f5f5;
        border-radius: 6px;
    }

    .controls button {
        padding: 8px 16px;
        background-color: #ff4444;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
    }

    .controls button:hover {
        background-color: #dd3333;
    }

    .selected-count {
        font-weight: bold;
        color: #555;
    }

    .weekly-schedule {
        display: flex;
        flex-direction: row;
        overflow-x: scroll;
        gap: 20px;
    }

    .day-schedule {
        min-width: 210px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    }

    .day-header {
        margin: 0;
        padding: 12px;
        background-color: #4285f4;
        color: white;
        font-size: 16px;
        text-align: center;
    }

    .day-header span {
        opacity: 0.8;
        font-size: 14px;
    }

    .time-columns {
        display: flex;
        padding: 10px;
        gap: 10px;
    }

    .time-column {
        flex: 1;
    }

    .time-column h4 {
        text-align: center;
        margin: 0 0 8px 0;
        color: #555;
        font-size: 14px;
    }

    .time-slots {
        max-height: 250px;
        overflow-y: auto;
        border: 1px solid #eee;
        border-radius: 6px;
        padding: 5px 0;
    }

    .time-slot {
        padding: 8px 12px;
        margin: 2px 5px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        transition: all 0.2s;
    }

    .time-slot:hover {
        background-color: #e8f0fe;
    }

    .time-slot.selected {
        background-color: #34a853;
        color: white;
    }

    .time-slot.disabled {
        color: #ccc;
        cursor: not-allowed;
    }

    .time-slot.disabled:hover {
        background-color: transparent;
    }

    .selected-interval {
        text-align: center;
        padding: 8px;
        font-size: 14px;
        color: #34a853;
        font-weight: bold;
        border-top: 1px solid #eee;
    }

    .selected-intervals {
        margin-top: 30px;
        padding: 20px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        background-color: #f9f9f9;
    }

    .selected-intervals h3 {
        margin-top: 0;
        color: #555;
    }

    .selected-intervals ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .selected-intervals li {
        padding: 8px 12px;
        margin-bottom: 6px;
        background-color: white;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-left: 3px solid #4285f4;
    }

    .remove-btn {
        background: none;
        border: none;
        color: #ff4444;
        font-size: 18px;
        cursor: pointer;
        padding: 0 5px;
        line-height: 1;
    }
`;
